import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import qs from "qs";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
import store from "store";
import Socket from "utils/socket/public";
import { get_depth } from "api/v4/market";
import { post_etfNetWorth } from "api/old/xt-redemption";

import useTimeout from "hooks/useTimeout";
import useAxiosCancelFun from "hooks/useAxiosCancelFun";
import XtFontScale from "components/xt/fontScale";
import XtLoading from "components/xt/loading";
import XtScrollLay from "components/xt/scroll/lay";

import CMPT_Option from "./option";
import CMPT_List from "./list";
import CMPT_Recent from "./recent";

import styles from "./index.module.scss";

import { BreakpointEnum, LayoutEnum } from "store/app";
import { DepthAryProps, LayoutAdvancedActiveKeyEnum, LayoutH5ActiveKeyEnum } from "store/trade";
// const { XtContext } = Context;
const { useTranslation } = Hooks;
const { Big } = Util;

export enum LayEnum {
  ask2bid = "ask2bid", //显示卖盘买盘
  ask = "ask", //显示卖盘
  bid = "bid", //显示买盘
}

interface WsDepthProps {
  s: string; //交易对
  a?: Array<Array<string>>; //卖盘数组
  b?: Array<Array<string>>; //买盘数组
  fi: number; //firstUpdateId 等于上一次推送的lastUpdateId + 1
  i: number; //lastUpdateId
}
interface apiDepthProps {
  asks: Array<Array<string>>; //卖盘数组
  bids: Array<Array<string>>; //买盘数组
  lastUpdateId: number; //lastUpdateId
  timestamp: number; //时间戳
}

const WindowUl: React.FC<any> = ({ record, depthType, maxAmount, openOrderObj }) => {
  // console.log("record===", record);
  return record.map((item) => {
    return <CMPT_List key={`${item[0]}`} ary={item} depthType={depthType} maxAmount={maxAmount} openOrderObj={openOrderObj} />;
  });
};

const Main: React.FC = () => {
  const t = useTranslation();

  const { breakpoint, layout } = store.app;
  const { name, currentConfig, isEtf } = store.market;
  const { tradeRecent, depthAsks, depthBids, layoutAdvancedActiveKey, layoutH5ActiveKey } = store.trade;
  const { openOrder } = store.balances;

  const coinSell = useMemo(() => {
    return (name.split("_")[0] || "").toUpperCase();
  }, [name]);
  const coinBuy = useMemo(() => {
    return (name.split("_")[1] || "").toUpperCase();
  }, [name]);
  const openOrderObj = useMemo<ObjAny>(() => {
    if (!openOrder || !openOrder.length) return {};

    const obj = {};
    openOrder.map((doc) => {
      if (doc.symbol !== name) return;
      obj[doc.price] = true;
    });
    return obj;
  }, [openOrder, name]); //当前挂单价格对象

  const [lay, setLay] = useState<LayEnum>(LayEnum.ask2bid);
  const [loading, setLoading] = useState<boolean>(true);
  const setLoadingFalse = useCallback(() => setLoading(false), []);
  const [timeoutLoading, timeoutLoadingClear] = useTimeout(setLoadingFalse, { ms: 2000 });

  const isHasReady = useRef<boolean>(false); //该交易对是否有过一次正常连续情况
  const isCacheWs = useRef<boolean>(true); //是否缓存ws
  const wsCacheAry = useRef<WsDepthProps[]>([]); //ws缓存集合
  const wsLatest = useRef<WithUndefined<WsDepthProps>>(); //最新推送的ws

  const depthLimit = 20; // depth 通道与 REST 统一使用 20 档
  const apiReqDepthArg = useMemo(() => {
    return {
      fn: get_depth,
      config: {
        params: {
          symbol: name,
          limit: depthLimit,
        },
      },
    };
  }, [name]);
  const apiReqDepth = useAxiosCancelFun(apiReqDepthArg);

  /*
  const cancelFun = useRef<any>();
  const apiReqDepth2 = useCallback(
    (callback) => {
      if (cancelFun.current) {
        cancelFun.current();
        cancelFun.current = null;
      }
      get_depth({
        params: {
          symbol: name,
          // limit: 50,
        },
        cancelFun: (c) => (cancelFun.current = c),
      })
        .then((data) => {
          callback && callback(data);
        })
        .catch((error) => {
          if (error.isCancel) return;
          callback && callback();
        })
        .finally(() => {
          cancelFun.current = null;
        });
    },
    [name]
  );
   */
  const mixDepthArray = useCallback((array, newArray) => {
    const retAry = [...array];
    if (!newArray || !newArray.length) return retAry;
    newArray.map((ary) => {
      const price = ary[0];
      const num = +ary[1];
      const index = retAry.findIndex((tar) => tar[0] === price);

      if (num) {
        if (index < 0) {
          retAry.push(ary);
        } else {
          retAry.splice(index, 1, ary);
        }
      } else {
        if (index < 0) {
          //无
        } else {
          retAry.splice(index, 1);
        }
      }
    });
    return retAry;
  }, []); //盘口增量数据与当前数组进行混合，返回新数组
  const sumTotal = useCallback((array: Array<Array<string>>, isReverse?: boolean, dp?) => {
    const newAry: Array<Array<string>> = [];
    let ary: Array<string> = [];
    let count = "0";

    if (!isReverse) {
      for (let i = 0; i < array.length; i++) {
        ary = [...array[i].slice(0, 2)];
        count = Big(count)
          .plus(ary[1] || 0)
          .toFixed(dp);
        ary.push(count);
        newAry.push(ary);
      }
    } else {
      for (let i = array.length - 1; i >= 0; i--) {
        ary = [...array[i].slice(0, 2)];
        count = Big(count)
          .plus(ary[1] || 0)
          .toFixed(dp);
        ary.push(count);
        newAry.unshift(ary);
      }
    }

    return newAry;
  }, []); //统计累计数量，返回新数组，ary[2] 就是累计
  const dataUpdate = useCallback((data: { asks?: Array<Array<string>>; bids?: Array<Array<string>> }, isFull?: boolean) => {
    const { asks, bids } = data;
    let retAsks, retBids;
    if (isFull) {
      retAsks = asks || [];
      retBids = bids || [];
    } else {
      retAsks = mixDepthArray(store.trade.depthAsks, asks);
      retBids = mixDepthArray(store.trade.depthBids, bids);
    }

    retAsks.sort((a, b) => b[0] - a[0]); //从大到小排序
    retBids.sort((a, b) => b[0] - a[0]); //从大到小排序

    retAsks = sumTotal(retAsks, true);
    retBids = sumTotal(retBids);

    store.trade.updateState({
      depthAsks: retAsks,
      depthBids: retBids,
    });
  }, []); //数据更新
  const refRetryCount = useRef<number>(0);
  const spliceData = useCallback((data: WithUndefined<apiDepthProps>): true | undefined => {
    let index = 0;
    if (!data) return true;
    if (data && data.lastUpdateId) {
      if (!wsCacheAry.current.length) {
        wsLatest.current = {
          i: data.lastUpdateId,
          fi: data.lastUpdateId,
          s: name,
        };
      } else {
        let doc, isOK;
        for (let i = 0; i < wsCacheAry.current.length; i++) {
          doc = wsCacheAry.current[i];
          if (doc.fi - 1 === data.lastUpdateId) {
            index = i;
            isOK = true;
            break;
          }
          if (doc.i === data.lastUpdateId) {
            index = i + 1;
            isOK = true;
            break;
          }
        }
        if (!isOK) {
          console.log("不连续拼接=====", name, data, wsCacheAry.current);
          // return retry();

          if (!isHasReady.current) {
            //如果从没有正常连续情况
            console.log("从没有正常连续情况，使用接口数据展示");
            isHasReady.current = true;
            dataUpdate(data, true);
          }

          return true;
        }
      }
    }

    let asks: Array<Array<string>> = [],
      bids: Array<Array<string>> = [];
    if (data) {
      asks = data.asks;
      bids = data.bids;
    }

    for (let i = index; i < wsCacheAry.current.length; i++) {
      asks = mixDepthArray(asks, wsCacheAry.current[i].a);
      bids = mixDepthArray(bids, wsCacheAry.current[i].b);
    }

    dataUpdate({ asks, bids }, true);

    isCacheWs.current = false;
    wsCacheAry.current = [];

    refRetryCount.current = 0;
    isHasReady.current = true;
  }, []); //数据拼接
  const refRetryTimeout = useRef<number>();
  const retry = useCallback(
    (data?: WsDepthProps) => {
      isCacheWs.current = true;
      wsCacheAry.current = data ? [data] : [];
      wsLatest.current = data;
      console.log("depth_update@ retry", refRetryTimeout.current);

      if (refRetryTimeout.current) return;
      refRetryCount.current = refRetryCount.current + 1;
      refRetryTimeout.current = window.setTimeout(() => {
        refRetryTimeout.current = 0;
        console.log("depth_update@ retry start");
        apiReqDepth(({ err, data, config }) => {
          console.log("depth_update@ config", config);
          if (!(config && config.params && config.params.symbol === store.market.name)) {
            console.log("depth_update@ config.params.symbol !== name", config.params.symbol, store.market.name);
            return;
          }
          const rst = spliceData(err ? undefined : data);
          rst && retry();
        });
      }, (refRetryCount.current > 3 ? 3 : refRetryCount.current) * 200);
    },
    [apiReqDepth, spliceData]
  );
  useEffect(() => {
    isHasReady.current = false;
    refRetryCount.current = 0;
    if (refRetryTimeout.current) {
      clearTimeout(refRetryTimeout.current);
      refRetryTimeout.current = 0;
    }
  }, [name]);

  const wsCallback = (data: WsDepthProps) => {
    // console.log("depth_update@ ws data", data);
    if (data.s !== store.market.name) {
      console.log("depth_update@ name !== data.s", store.market.name, data.s);
      return;
    }
    if (wsLatest.current && wsLatest.current.i !== data.fi - 1) {
      console.log("ws 不连续=====", { name, wsLatest: wsLatest.current, ws: data });
      return retry(data);
    }
    wsLatest.current = data;
    console.log("wsCacheAry=", wsCacheAry.current);
    if (isCacheWs.current) return wsCacheAry.current.push(data);

    dataUpdate({
      asks: data.a,
      bids: data.b,
    });
  };

  // depth@ 全量快照：收到后直接全量更新盘口
  const wsCallbackDepth = (data: { s?: string; asks?: Array<Array<string>>; bids?: Array<Array<string>>; a?: Array<Array<string>>; b?: Array<Array<string>> }) => {
    if (data.s !== store.market.name) return;
    const asks = data.asks ?? data.a ?? [];
    const bids = data.bids ?? data.b ?? [];
    dataUpdate({ asks, bids }, true);
  };

  const [depthMerge, setDepthMerge] = useState<string>();
  const depthMergeFixed = useMemo<number>(() => {
    if (!depthMerge) return 0;
    const str = depthMerge.split(".")[1];
    return str ? str.length : 0;
  }, [depthMerge]);
  const depthMergeFun = useCallback(
    (depthAry, rm, isReverse) => {
      if (!depthMerge) return depthAry;
      const { quantityPrecision } = currentConfig;
      const retAry: DepthAryProps = [];
      depthAry.map((ary) => {
        const price = Big(
          Big(ary[0] || 0)
            .div(depthMerge)
            .toFixed(0, rm)
        )
          .times(depthMerge)
          .toFixed(depthMergeFixed);
        const lastRetAry = retAry[retAry.length - 1];
        if (lastRetAry) {
          if (price === lastRetAry[0]) {
            lastRetAry[1] = Big(lastRetAry[1] || 0)
              .plus(ary[1] || 0)
              .toFixed(quantityPrecision);
            // lastRetAry[2] = Big(lastRetAry[2] || 0).plus(ary[2] || 0).toFixed(quantityPrecision);
            return;
          }
        }

        retAry.push([price, Big(ary[1] || 0).toFixed(quantityPrecision)]);
      });
      // return retAry;
      return sumTotal(retAry, isReverse, quantityPrecision);
    },
    [depthMerge, depthMergeFixed, currentConfig, sumTotal]
  );
  const depthAsksWithMerge = useMemo(() => {
    if (!depthAsks) return depthAsks;
    return depthMergeFun(depthAsks, 3, true);
  }, [depthMergeFun, depthAsks]);
  const depthBidsWithMerge = useMemo(() => {
    if (!depthBids) return depthBids;
    return depthMergeFun(depthBids, 0, false);
  }, [depthMergeFun, depthBids]);
  const asksMaxAmount = useMemo<number>(() => {
    let max = 0;
    (depthAsksWithMerge || []).map((item: any[]) => {
      if (item[1] - max > 0) max = +item[1];
    });
    return max;
  }, [depthAsksWithMerge]); //卖方最大数量
  const bidsMaxAmount = useMemo<number>(() => {
    let max = 0;
    (depthBidsWithMerge || []).map((item: any[]) => {
      if (item[1] - max > 0) max = +item[1];
    });
    return max;
  }, [depthBidsWithMerge]); //买方最大数量

  useEffect(() => {
    console.log("depth_update@ add", name);
    const msg = { event: `depth_update@${name}` };
    const msgDepth = { event: `depth@${name},${depthLimit}` };

    Socket.addChannel(msg, wsCallback);
    Socket.addChannel(msgDepth, wsCallbackDepth);
    const cancelFun = apiReqDepth(({ err, data, config }) => {
      console.log("depth_update@ config", config);
      if (store.market.name !== name) return;
      if (!(config && config.params && config.params.symbol === name)) {
        console.log("depth_update@ config.params.symbol !== name", config.params.symbol, name);
        return;
      }
      const rst = spliceData(err ? undefined : data);
      rst && retry();
      timeoutLoading();
    });

    return () => {
      // if (cancelFun.current) {
      //   cancelFun.current();
      //   cancelFun.current = null;
      // }
      console.log("depth_update@ remove", name);
      cancelFun && cancelFun.current && cancelFun.current();
      timeoutLoadingClear();
      isCacheWs.current = true;
      wsCacheAry.current = [];
      wsLatest.current = undefined;

      setLoading(true);
      Socket.removeChannel(msg);
      Socket.removeChannel(msgDepth);
      store.trade.updateState({ depthAsks: undefined, depthBids: undefined });
    };
  }, [name]);
  useEffect(() => {
    if (loading && tradeRecent !== undefined && (depthAsks || depthBids)) {
      timeoutLoadingClear();
      setLoadingFalse();
    }
  }, [tradeRecent, depthAsks, depthBids]);

  const apiReqEtfNetWorth = useCallback(() => {
    post_etfNetWorth({
      data: qs.stringify({ dealPair: name }),
    }).then((netWorth) => {
      store.market.updateState({ netWorth });
    });
  }, [name]);
  const [timeoutEtfNetWorth, timeoutEtfNetWorthClear] = useTimeout(apiReqEtfNetWorth, { ms: 5000, isLoop: true, isInitExec: true });
  useEffect(() => {
    store.market.updateState({ netWorth: "" });
  }, [name]);
  useEffect(() => {
    timeoutEtfNetWorthClear();
    if (isEtf) {
      // console.log("is etf timeoutEtfNetWorth");
      timeoutEtfNetWorth();
    }
  }, [name, isEtf]);

  const isHide = useMemo(() => {
    //isH5
    if (breakpoint === BreakpointEnum.sm) {
      if (layoutH5ActiveKey !== LayoutH5ActiveKeyEnum.order) return true;
      else return false;
    }
    //专业版布局
    if (layout === LayoutEnum.advanced) {
      if (breakpoint === BreakpointEnum.xl) return false;
      if (layoutAdvancedActiveKey !== LayoutAdvancedActiveKeyEnum.order) return true;
      else return false;
    }

    return false;
  }, [breakpoint, layoutH5ActiveKey, layout, layoutAdvancedActiveKey]);
  if (isHide) return <></>;

  return (
    <div className={styles.main}>
      <CMPT_Option atvLay={lay} onLayChange={(lay) => setLay(lay)} depthMerge={depthMerge} setDepthMerge={setDepthMerge} />
      <div className={styles.nav}>
        <XtFontScale isLoop>{t("trade.price") + (coinBuy.length < 7 ? `(${coinBuy})` : "")}</XtFontScale>
        <XtFontScale isLoop>{t("trade.amount") + (coinSell.length < 7 ? `(${coinSell})` : "")}</XtFontScale>
        <XtFontScale isLoop>{t("trade.total") + (coinSell.length < 7 ? `(${coinSell})` : "")}</XtFontScale>
      </div>

      <div className={styles.content}>
        {loading && <XtLoading />}
        {!loading && (
          <>
            {lay !== LayEnum.bid && (
              <XtScrollLay className={cx(styles.scrollWindowAsk)} height={20} dataAry={depthAsksWithMerge || []} isReverse={true}>
                <WindowUl depthType={LayEnum.ask} maxAmount={asksMaxAmount} openOrderObj={openOrderObj} />
              </XtScrollLay>
            )}
            <CMPT_Recent />
            {lay !== LayEnum.ask && (
              <XtScrollLay className={cx(styles.scrollWindowBid)} height={20} dataAry={depthBidsWithMerge || []}>
                <WindowUl depthType={LayEnum.bid} maxAmount={bidsMaxAmount} openOrderObj={openOrderObj} />
              </XtScrollLay>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default observer(Main);
